import { sb } from './supabase-client.js';

let galleryMedia = [];
let currentLbIndex = 0;

export async function initGallery(active_project) {
  try {
    const { data, error } = await sb
      .from('project_media')
      .select('*')
      .eq('project_id', active_project)
      .order('created_at', { ascending: false });

    if (error) throw error;
    if (!data || data.length === 0) return;

    galleryMedia = data;

    const btnGalleryMobile = document.getElementById('btn-gallery-mobile');
    if (btnGalleryMobile) {
      btnGalleryMobile.style.display = 'flex';
      btnGalleryMobile.addEventListener('click', toggleGalleryModal);
    }

    const btnGalleryDesktop = document.getElementById('btn-gallery-desktop');
    if (btnGalleryDesktop) {
      btnGalleryDesktop.style.display = 'flex';
      btnGalleryDesktop.addEventListener('click', toggleGalleryModal);
    }

    buildGalleryGrid();
    setupGalleryModalListeners();
    setupLightbox();

  } catch (err) {
    console.error('[Gallery Error] Failed to init gallery:', err);
  }
}

function getYouTubeId(url) {
  const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})/);
  return match ? match[1] : null;
}

function buildGalleryGrid() {
  const grid = document.getElementById('gallery-grid');
  if (!grid) return;
  grid.innerHTML = '';

  galleryMedia.forEach((media, index) => {
    const item = document.createElement('div');
    item.className = 'masonry-item';
    item.dataset.index = index;

    let thumbUrl = '';
    let isVideo = false;

    if (media.media_type === 'video_link' || (media.storage_url && media.storage_url.includes('youtu'))) {
      isVideo = true;
      const ytId = getYouTubeId(media.storage_url);
      thumbUrl = ytId ? `https://img.youtube.com/vi/${ytId}/maxresdefault.jpg` : media.storage_url;
    } else {
      thumbUrl = media.storage_url;
    }

    item.innerHTML = `<img src="${thumbUrl}" alt="Gallery media ${index + 1}" loading="lazy">`;

    if (isVideo) {
      item.innerHTML += `
        <div class="play-icon">
          <svg viewBox="0 0 24 24">
            <path d="M8 5v14l11-7z" />
          </svg>
        </div>
      `;
    }

    item.addEventListener('click', () => openLightbox(index));
    grid.appendChild(item);
  });
}

function toggleGalleryModal() {
  const modal = document.getElementById('gallery-modal');
  if (modal) {
    if (modal.classList.contains('show')) {
      closeGalleryModal();
    } else {
      modal.classList.add('show');
    }
  }
}

function closeGalleryModal() {
  const modal = document.getElementById('gallery-modal');
  if (modal) modal.classList.remove('show');
}

function setupGalleryModalListeners() {
  document.addEventListener('click', (e) => {
    const modal = document.getElementById('gallery-modal');
    const btnGalleryMobile = document.getElementById('btn-gallery-mobile');
    const btnGalleryDesktop = document.getElementById('btn-gallery-desktop');

    if (modal && modal.classList.contains('show')) {
      const lb = document.getElementById('gallery-lightbox');
      const clickedMobile = btnGalleryMobile && btnGalleryMobile.contains(e.target);
      const clickedDesktop = btnGalleryDesktop && btnGalleryDesktop.contains(e.target);
      const clickedLightbox = lb && lb.contains(e.target);

      if (!modal.contains(e.target) && !clickedMobile && !clickedDesktop && !clickedLightbox) {
        closeGalleryModal();
      }
    }
  });
}

// ── Lightbox Logic ──

function setupLightbox() {
  const gmClose = document.getElementById('gm-close');
  if (gmClose) gmClose.addEventListener('click', closeGalleryModal);

  const lbClose = document.getElementById('lb-close');
  const lbPrev = document.getElementById('lb-prev');
  const lbNext = document.getElementById('lb-next');

  if (lbClose) lbClose.addEventListener('click', closeLightbox);
  if (lbPrev) lbPrev.addEventListener('click', () => navigateLightbox(-1));
  if (lbNext) lbNext.addEventListener('click', () => navigateLightbox(1));

  document.addEventListener('keydown', (e) => {
    const lb = document.getElementById('gallery-lightbox');
    if (lb && lb.classList.contains('show')) {
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') navigateLightbox(-1);
      if (e.key === 'ArrowRight') navigateLightbox(1);
    } else {
      const modal = document.getElementById('gallery-modal');
      if (modal && modal.classList.contains('show') && e.key === 'Escape') {
        closeGalleryModal();
      }
    }
  });
}

function openLightbox(index) {
  currentLbIndex = index;
  renderLightboxContent();
  const lb = document.getElementById('gallery-lightbox');
  if (lb) lb.classList.add('show');
}

function closeLightbox() {
  const lb = document.getElementById('gallery-lightbox');
  if (lb) lb.classList.remove('show');

  // Clear content to stop any ghost audio from playing
  const content = document.getElementById('lb-content');
  if (content) content.innerHTML = '';
}

function navigateLightbox(dir) {
  currentLbIndex += dir;
  if (currentLbIndex < 0) currentLbIndex = galleryMedia.length - 1;
  if (currentLbIndex >= galleryMedia.length) currentLbIndex = 0;

  // Clear content immediately before rendering new one to ensure strict audio cutoff
  const content = document.getElementById('lb-content');
  if (content) content.innerHTML = '';

  renderLightboxContent();
}

function renderLightboxContent() {
  const content = document.getElementById('lb-content');
  if (!content) return;
  content.innerHTML = '';

  const media = galleryMedia[currentLbIndex];
  if (!media) return;

  const isVideo = media.media_type === 'video_link' || (media.storage_url && media.storage_url.includes('youtu'));

  if (isVideo) {
    const ytId = getYouTubeId(media.storage_url);
    if (ytId) {
      const embedUrl = `https://www.youtube.com/embed/${ytId}?autoplay=1&rel=0`;
      content.innerHTML = `<iframe src="${embedUrl}" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
    } else {
      content.innerHTML = `<video src="${media.storage_url}" autoplay controls style="max-width:100%;max-height:100%;border-radius:8px;box-shadow: 0 20px 60px rgba(0,0,0,0.8);"></video>`;
    }
  } else {
    content.innerHTML = `<img src="${media.storage_url}" alt="Gallery Fullsize">`;
  }
}
